/**
 * Parent page → iframe `postMessage` contract for dialog/overlay positioning when the iframe
 * is sized to the full document height but only part of it is visible in the parent viewport.
 */
export const EMBED_PARENT_VIEWPORT_TYPE = 'EMBED_PARENT_VIEWPORT';

/** Iframe asks the parent to send {@link EMBED_PARENT_VIEWPORT_TYPE} (after listeners are ready). */
export const IFRAME_EMBED_REQUEST_PARENT_VIEWPORT_TYPE =
  'IFRAME_EMBED_REQUEST_PARENT_VIEWPORT';
